import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../../../admin/src/app/services/auth.service';
import { UserService } from '../../../../../admin/src/app/services/user.service';
import { Router, ActivatedRoute, RoutesRecognized, NavigationEnd } from '@angular/router';
import { LanguageService } from '../../services/language.service';
import { RoutingStateService } from '../../services/routing-state.service';
import { MatomoTracker } from 'ngx-matomo';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {

  loginUrl: string;
  showLogo = false;
  showLogin = true;

  private routerSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authSvc: AuthService,
    private userSvc: UserService,
    public language: LanguageService,
    private routingState: RoutingStateService,
    private matomoTracker: MatomoTracker
  ) { }

  ngOnInit() {
    this.routingState.getShowHeaderLogo.subscribe(show => {
      this.showLogo = show;
    });
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showLogin = !event.url.includes('/delete-account');
      }
    });
    this.showLogin = !this.router.url.includes('/delete-account');
  }

  ngOnDestroy(): void {
    this.routerSub.unsubscribe();
  }

  isUserLoggedIn() {
    return !!this.authSvc.getCurrentToken();
  }

  getUserName() {
    let user = this.userSvc.getUserInfo();
    if (!!user) {
      this.matomoTracker.setUserId('' + user.id);
      return !!(user.firstName || user.lastName) ? `${user.firstName} ${user.lastName}` : user.email;
    } else {
      this.matomoTracker.resetUserId();
      return '';
    }
  }

  logout() {
    this.authSvc.invalidateCurrentToken();
    this.matomoTracker.resetUserId();
    if (this.router.url.includes('/profile')) {
      this.router.navigate(['/']);
    } else {
      this.router.navigate(['./'], { relativeTo: this.route });
    }
  }

  setLang(lang: string): void {
    let url = this.router.url;
    const index = url.indexOf('?')
    if (index !== -1) {
      url = url.substring(0, index);
    }
    if (url.length < 3) {
      return;
    }
    let newUrl = '/' + lang + url.substring(3);
    this.router.navigate([newUrl]).then(() => {
      window.location.reload();
    });
  }

  getLang(): string {
    return this.language.getLang();
  }
}
